document.addEventListener('DOMContentLoaded', () => {

  // Qty stepper
  document.querySelectorAll('.nsp-pdp__qty-stepper').forEach((stepper) => {
    const input = stepper.querySelector('.nsp-pdp__qty-input');
    if (!input) return;
    stepper.querySelectorAll('[data-qty-action]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const current = parseInt(input.value, 10) || 1;
        if (btn.dataset.qtyAction === 'increase') {
          input.value = current + 1;
        } else if (btn.dataset.qtyAction === 'decrease' && current > 1) {
          input.value = current - 1;
        }
      });
    });
  });

  // Variant selector
  document.querySelectorAll('[data-nsp-variant-form]').forEach((form) => {
    const dataEl = form.querySelector('[data-nsp-variant-json]');
    if (!dataEl) return;

    const variants = JSON.parse(dataEl.textContent);
    const idInput = form.querySelector('.nsp-pdp__variant-id');
    const addBtn = form.querySelector('.nsp-pdp__add');
    const addLabel = addBtn ? addBtn.dataset.addLabel : '';
    const soldOutLabel = addBtn ? addBtn.dataset.soldOutLabel : '';
    const addTextEl = addBtn ? addBtn.querySelector('.nsp-pdp__add-text') : null;
    const addPriceEl = addBtn ? addBtn.querySelector('[data-nsp-add-price]') : null;
    const addSepEl = addBtn ? addBtn.querySelector('.nsp-pdp__add-sep') : null;
    const priceEls = document.querySelectorAll('[data-nsp-price]');
    const fieldsets = [...form.querySelectorAll('fieldset[data-option-position]')].sort(
      (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
    );

    function selectedValues() {
      return fieldsets.map((fieldset) => {
        const checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(values) {
      return variants.find((variant) => values.every((value, index) => variant.options[index] === value));
    }

    function applyVariant(variant) {
      if (!variant || !addBtn) return;
      if (idInput) idInput.value = variant.id;

      priceEls.forEach((priceEl) => {
        priceEl.textContent = variant.price_formatted;
      });

      if (variant.available) {
        addBtn.disabled = false;
        addBtn.classList.remove('nsp-pdp__add--disabled');
        if (addTextEl) addTextEl.textContent = addLabel;
        if (addSepEl) addSepEl.style.display = '';
        if (addPriceEl) {
          addPriceEl.style.display = '';
          addPriceEl.textContent = variant.price_formatted;
        }
      } else {
        addBtn.disabled = true;
        addBtn.classList.add('nsp-pdp__add--disabled');
        if (addTextEl) addTextEl.textContent = soldOutLabel;
        if (addSepEl) addSepEl.style.display = 'none';
        if (addPriceEl) addPriceEl.style.display = 'none';
      }
    }

    fieldsets.forEach((fieldset) => {
      fieldset.addEventListener('change', () => {
        const selectedEl = fieldset.querySelector('.nsp-pdp__option-selected');
        const checked = fieldset.querySelector('input:checked');
        if (selectedEl && checked) selectedEl.textContent = checked.value;
        applyVariant(findVariant(selectedValues()));
      });
    });
  });

});
